const languageCodeLabels = {
  'af-ZA': 'Afrikaans (South Africa)',
  'ar-AE': 'Arabic (U.A.E.)',
  'ar-SA': 'Arabic (Saudi Arabia)',
  'eu-ES': 'Basque (Spain)',
  'ca-ES': 'Catalan (Spain)',
  'zh-HK': 'Chinese (Hong Kong)',
  'zh-CN': 'Chinese (Mandarin, simplified)',
  'zh-TW': 'Chinese (Taiwanese Mandarin)',
  'hr-HR': 'Croatian (Croatia)',
  'cs-CZ': 'Czech (Czech Republic)',
  'da-DK': 'Danish (Denmark)',
  'nl-NL': 'Dutch (Netherlands)',
  'en-AU': 'English (Australia)',
  'en-GB': 'English (United Kingdom)',
  'en-IN': 'English (India)',
  'en-IE': 'English (Ireland)',
  'en-NZ': 'English (New Zealand)',
  'en-AB': 'English (Aboriginal)',
  'en-ZA': 'English (South Africa)',
  'en-US': 'English (United States)',
  'en-WL': 'English (Welsh)',
  'fa-IR': 'Farsi (Iran)',
  'fi-FI': 'Finnish (Finland)',
  'fr-FR': 'French (France)',
  'fr-CA': 'French (Canada)',
  'gl-ES': 'Galician (Spain)',
  'de-DE': 'German (Germany)',
  'de-CH': 'German (Switzerland)',
  'el-GR': 'Greek (Greece)',
  'he-IL': 'Hebrew (Israel)',
  'hi-IN': 'Hindi (India)',
  'id-ID': 'Indonesian (Indonesia)',
  'it-IT': 'Italian (Italy)',
  'ja-JP': 'Japanese (Japan)',
  'ko-KR': 'Korean (Korea)',
  'lv-LV': 'Latvian (Latvia)',
  'ms-MY': 'Malay (Malaysia)',
  'no-NO': 'Norwegian (Norway)',
  'pl-PL': 'Polish (Poland)',
  'pt-PT': 'Portuguese (Portugal)',
  'pt-BR': 'Portuguese (Brazil)',
  'ro-RO': 'Romanian (Romania)',
  'ru-RU': 'Russian (Russia)',
  'sr-RS': 'Serbian (Serbia)',
  'sk-SK': 'Slovak (Slovakia)',
  'so-SO': 'Somali (Somalia)',
  'es-ES': 'Spanish (Spain)',
  'es-US': 'Spanish (United States)',
  'sv-SE': 'Swedish (Sweden)',
  'tl-PH': 'Tagalog (Philippines)',
  'th-TH': 'Thai (Thailand)',
  'uk-UA': 'Ukrainian (Ukraine)',
  'vi-VN': 'Vietnamese (Vietnam)',
  'zu-ZA': 'Zulu (South Africa)',
};

const languageCodes = Object.keys(languageCodeLabels);

export function validateLanguageCode(langCode) {
  return languageCodes.includes(langCode);
}

export function languageCodesWithLabels() {
  return languageCodeLabels;
}
